import React from "react";
import { Outlet, useNavigate } from "react-router";
import { Link, NavLink } from "react-router-dom";
import "../sidebar/Sidebar.css";
import sidebar_logo from "../../assets/Account_logo.png";
import Overview_img from "../../assets/Overview.png";
import groups_img from "../../assets/groups.png";
import msg from "../../assets/msg.png";
import DashboardHeader from "../header/DashboardHeader";
import Categories from "../../pages/dashboard/Categories/Categories";
import { Categorie, logicalIcon, logicalicon_blue } from "../../assets";
import { FaTimes } from "react-icons/fa";

const Sidebar = () => {
  const navigate = useNavigate();
  const mobileMenu = () => {
    document.body.classList.remove("menuOpen");
  };
  return (
    <div className="dashboard">
      <div className="sideNav">
        <button type="button" onClick={mobileMenu} className="cross_sidenav">
          <FaTimes />
        </button>
        <div className="logo_section">

          <Link to="/dashboard/overview">
            <img
              // src={sidebar_logo}
              src={logicalicon_blue}
              // onClick={(e) => {
              //   e.preventDefault();
              //   // navigate("/");
              // }}
              alt="Logo-Logical"
            />
          </Link>

        </div>


        <ul className="sidebar_list">
          <li>
            <NavLink to="/dashboard/message/group">
              <img src={msg} alt="" />
              <p>Group Chat</p>
            </NavLink>
          </li>
          <li>
            {/* <NavLink to="/dashboard/message"> */}
            <NavLink to={'/dashboard/message/member'}>
              <img src={msg} alt="" />
              <p>Member Chat</p>
            </NavLink>
          </li>
          <li>
            <NavLink to="/dashboard/overview">
              <img src={Overview_img} />
              <p>Feeds</p>
            </NavLink>
          </li>

          <li>
            <NavLink to="/dashboard/group">
              <img src={groups_img} />
              <p>Groups</p>
            </NavLink>
          </li>

          <li>
            <NavLink to="/dashboard/category">
              <img src={Categorie} alt="" />
              <p>Categories</p>
            </NavLink>
          </li>

        </ul>


      </div>

      <div className="dashboard_inner_content">
        <Outlet />
      </div>
    </div>
  );
};

export default Sidebar;
